import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { isIframeRoot } from "../utils/commonUtils";

export default function Layout() {
  const allowedFooterPaths = ["/", "/faqs"];
  const { pathname } = useLocation();
  const isIframe = isIframeRoot();

  const isApiKeyManagement = pathname.startsWith("/api-key-management");

  return (
    <>
      {!isIframe && !isApiKeyManagement && <Header />}
      <main>
        <Outlet />
      </main>
      {!isIframe && allowedFooterPaths.includes(pathname.toLowerCase()) && (
        <Footer />
      )}
    </>
  );
}
